<template>
    <div>
        <Header></Header>
        <div class="top-message">
            <h1>おしらせ</h1>   
        </div>
        <div class="informationList">
            <ul>
                <li v-for="notification in notifications" :key="notification.itemID">
                    <article>
                        <button v-if="!notification.isRead" class="isRead">未読</button><p>{{notification.information}}</p>
                        <button class="goTrade" @click="selected(notification.itemID)">商品ページへ</button>
                    </article>
                </li>
            </ul>
        </div>
        <menu-bar class="menu-bar"></menu-bar>

    </div>
</template>

<script>
import Header from '../components/Header.vue'
import db from '../plugins/firestore'
import firebase from '../plugins/firebase'
import MenuBar from '../components/MenuBar.vue'


export default {
    components: {Header,MenuBar},
    data(){
        return {
            userID: '',
            notifications:[],
            itemInformation:'' //商品ページへがクリックされたときにvuexに商品情報を突っ込むための変数
        }
    },
    created(){
        firebase.auth().onAuthStateChanged(user => {
            if(!user){
                this.$router.push({path: "/"})
            }else{
                this.userID = user.uid
                var userID = user.uid
                db.collection("users").doc(userID).collection("information").orderBy("timestamp", "desc").get().then(snap => {
                    const array = [];
                    snap.forEach(doc => {
                        const itemData = doc.data(); //itemDataオブジェクト（商品情報）を設定
                        itemData.itemID = doc.id; //itemDataにドキュメントIDを付与(商品ID)
                        array.push(itemData); //itemDataを配列arrayに入れる
                    });
                    this.notifications = array
                });
            }
        })
    },
    methods: {
        selected(itemID){
            //商品ページへがクリックされたら、itemIDをもとにfirestoreから商品情報を取得して、vuexに入れてからitemDetailに画面遷移
            var self = this
            db.collection("users").doc(this.userID).collection("information").doc(itemID).update({
                isRead: true
            })
            db.collection("textbooks").doc(itemID).get().then(function(doc){
                self.itemInformation = doc.data()
                self.itemInformation.itemID = doc.id
            }).then(()=>{
                this.$store.dispatch('selected', this.itemInformation)
                this.$router.push({name: 'itemDetail', params:{id: this.itemInformation.itemID}})
            })
        }
    }
}
</script>

<style scoped>
ul {
    list-style: none;
}

.informationList {
    margin: 0 auto;
    margin-top: 20px;
    width: 50%;
}

article {
	margin-bottom: 5px;
	padding: 15px;
	border-radius: 5px;
	box-sizing: border-box;
	box-shadow: 0 0 5px #999;
}

.goTrade {
    border-radius: 4px;
    color: white;
    margin-top: 5px;
    padding: 4px 20px;
    background-color: rgb(53, 174, 243);
    opacity: 0.8;
}

.isRead {
    display: inline-block;
    border-radius: 20px;
    color:white;
    margin-top: 5px;
    padding: 4px 20px;
    background-color:  rgba(255,0, 0, 1);
    opacity: 0.8;
}

@media all and (max-width:670px){
    .informationList {
        width: 90%;
    }
}
</style>
